var styles = {"box":"AuthPromo_box_lp17b_2","image-center":"AuthPromo_image-center_lp17b_7","image-right":"AuthPromo_image-right_lp17b_23","image-left":"AuthPromo_image-left_lp17b_36","content":"AuthPromo_content_lp17b_45","title":"AuthPromo_title_lp17b_53","list":"AuthPromo_list_lp17b_79","list__item":"AuthPromo_list__item_lp17b_84","bullet":"AuthPromo_bullet_lp17b_95"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
